import React, {FunctionComponent, useEffect, useState} from 'react';
import '@asseinfo/react-kanban/dist/styles.css'
import '../../../App.scss'
import {toast} from "react-toastify";
import TextField from "@material-ui/core/TextField";
import Button from '@material-ui/core/Button';
import OurPaperModal from "../../../components/OurPaperModal/OurPaperModal";
import Body1 from '../../../components/Typography/Body1';
import NegativeButton from "../../../components/CustomBottons/NegativeButton";
import OurToastContainer from "../../../components/OurToastContainer/OurToastContainer";
import {Auth} from "aws-amplify";
import {fetchPostBody} from "../../../utils/fetchUtils";
import {setPageTitle} from "../../../utils/titleUtils";

const StripeRefundToastContainerId = "StripeRefundToastContainerId";
const StripeRefundToastErrorId = "StripeRefundToastErrorId";
const StripeRefundToastSuccessId = "StripeRefundToastSuccessId";

const StripeRefundTool: FunctionComponent<{}> = () => {

  const [paymentId, setPaymentId] = useState<string>("");
  const [isConfirmPopupOpen, setIsConfirmPopupOpen] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);


  const notifyError = (message) => toast(message, {type: "error", pauseOnHover: true, toastId: StripeRefundToastErrorId, containerId: StripeRefundToastContainerId});
  const notifySuccess = (message) => toast(message, {type: "success", pauseOnHover: true, toastId: StripeRefundToastSuccessId, containerId: StripeRefundToastContainerId});

  useEffect(() => {
    setPageTitle("Stripe Refund");
  }, [])

  function handleStripeRefund() {
    setIsSubmitting(true);
    setIsConfirmPopupOpen(false);

    return Auth.currentAuthenticatedUser({bypassCache: false})
               .then(currUser => {
                 return fetchPostBody("admin/action", {"action": "stripeRefund", "paymentId": paymentId}, currUser.getSignInUserSession()?.getIdToken().getJwtToken())
                   .then(() => {
                     notifySuccess("Refund issued successfully!");
                     setPaymentId("");
                   })
                   .catch((err) => {
                     notifyError(err.message || "Something went wrong");
                   })
                   .finally(() => {
                     setIsSubmitting(false);
                   })
               })


  }

  return <>
    <div>
      <h6 className="semi-bold">Stripe Refund</h6>
      <div className="padding-bottom max-small-text-width">
        <TextField label="payment or commission ID"
                   fullWidth={true}
                   margin="dense"
                   onChange={(event) => setPaymentId(event.target.value)}
                   value={paymentId}
                   variant="outlined"/>
        <div className="padding-block-self"/>
        <Button color="primary"
                disabled={isSubmitting || paymentId.length === 0}
                onClick={(event) => setIsConfirmPopupOpen(true)}
                variant="contained"
        >
          Issue Refund
        </Button>

        <OurPaperModal parentToggle={isConfirmPopupOpen}
                       setParentClose={() => setIsConfirmPopupOpen(false)}
                       leftSideElement={<h6 className="semi-bold">Refund payment {paymentId}?</h6>}
        >
          <div className="center-text max-small-text-width flex-col-gap">
            <Body1 className="padding-bottom">
              Are you sure?
            </Body1>
            <div className="flex-row-gap">
              <NegativeButton onClick={() => setIsConfirmPopupOpen(false)}>
                no
              </NegativeButton>
              <Button color="primary"
                      autoFocus={true}
                      onClick={handleStripeRefund}
                      variant="contained">
                Yes
              </Button>
            </div>
          </div>
        </OurPaperModal>
      </div>
    </div>
    <OurToastContainer containerId={StripeRefundToastContainerId}/>
  </>;

}

export default StripeRefundTool;
